import {
    getAnalytics,
    logEvent,
    setAnalyticsCollectionEnabled,
} from "firebase/analytics";
import { initializeApp } from "firebase/app";

// Console
const firebaseConfig = {
    apiKey: "AIzaSyC4oZbxZJwKPCtJUaEIeDC9QTCdVL0N5uk",
    authDomain: "meta-appliner.firebaseapp.com",
    projectId: "meta-appliner",
    storageBucket: "meta-appliner.firebasestorage.app",
    messagingSenderId: "798609217868",
    appId: "1:798609217868:web:ede029b03a7911c28f17e9",
    measurementId: "G-EX41756VCX"
};

export const core = initializeApp(firebaseConfig);

// ANALYTICS
const analytics = getAnalytics(core);
setAnalyticsCollectionEnabled(analytics, true);

export const LogAnalytics = (name, params = {}) => {
    logEvent(analytics, name, params)
}